export const authErrors = {
    "Firebase: Error (auth/email-already-in-use).": "The email address is already in use by another account.",
    "Firebase: Error (auth/invalid-email).": "The email address is badly formatted.",
    "Firebase: Error (auth/user-not-found).": "There is no user record of this email. The user does not exist.",
    "Firebase: Error (auth/internal-error).": "There are errors in the input fields",
    "Firebase: Error (auth/wrong-password).": "The password you entered is incorrect",
    "Firebase: Password should be at least 6 characters (auth/weak-password).": "The password must be 6 characters long or more.",
}